import { Injectable } from '@angular/core';
import { ComponentCanDeactivate } from '../../models/protocols/component-can-deactivate';

import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

export const CanDeactivateState = {
  defendAgainstBrowserBackButton: false
};

@Injectable({
  providedIn: 'root'
})
export class CanDeactivateGuard {
  private approved = new WeakSet<ComponentCanDeactivate>();

  canDeactivate(component: ComponentCanDeactivate): boolean | Promise<boolean> | Observable<boolean> {
    if (this.approved.has(component)) {
      return true;
    }

    const deactivate$ = component.canDeactivate();

    if (typeof deactivate$ === 'boolean') {
      if (deactivate$) this.approved.add(component);
      return deactivate$;
    }

    if (deactivate$ instanceof Promise) {
      return deactivate$.then(value => {
        if (value) this.approved.add(component);
        return value;
      });
    }

    return deactivate$.pipe(
      map(value => {
        if (value) this.approved.add(component);
        return value;
      })
    );
  }
}
